import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { Appointment, DealerLocationID } from "models";
import type { PAGE_SIZE } from "utils/common";

export type ThreeDepartmentResponse = {
  items: Appointment[] | null;
  nb_items: number;
  nb_pages: number;
};

export enum NOT_CHECKED_BY {
  Receptionist = 1,
  Parts = 2,
  Workshop = 3
}

export type ThreeDepartmentFilters = {
  dealer_location_id: DealerLocationID | null;
  date_from: Date | null;
  date_to: Date | null;
  not_checked_by: NOT_CHECKED_BY | null;
  page: number;
  page_size: PAGE_SIZE;
};

const component = "ThreeDepartmentDashboard";

export const threeDepartmentQueryKeys = {
  filters: localQueryKey<ThreeDepartmentFilters>({ component, data: "filters" }),
  list: backendQueryKey<ThreeDepartmentResponse>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/three_departments/list" })
};
